import ScribeImageElementModel from 'js/models/ScribeImageElementModel';
import { mapSceneElementIdsToElements } from 'js/shared/helpers/scenesHelpers';
import { PlaybackScribeModel, ExistingScribeModel } from 'js/types';

export const getMaxCameraZoomForSceneImageIsIn = (
  image: ScribeImageElementModel,
  project: PlaybackScribeModel | ExistingScribeModel
) => {
  const sceneImageIsIn = project.scenes.find(scene => scene.elementIds.includes(image.id));

  if (!sceneImageIsIn) {
    return 1;
  }

  const cameras = mapSceneElementIdsToElements(project, sceneImageIsIn).filter(element => element.type === 'Camera');
  const maxZoom = Math.max(...cameras.map(cam => cam.scale));

  return maxZoom;
};
